export default __webpack_public_path__ + "static/media/landing.8c3ee664.svg";